export default class Cookie {
  static set(name, value = '', days = 0) {
    let date = new Date()
    date.setDate(date.getDate() + days)
    const expires = days ? date.toUTCString() : ''
    document.cookie = name + '=' + value.toString() + '; expires=' + expires + '; path=/;'
  }

  static get(name) {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(name+'='))
      ?.split("=")[1]
  }
}